import { render, staticRenderFns } from "./submitButton.component.vue?vue&type=template&id=ef82dc94&scoped=true"
import script from "./submitButton.component.vue?vue&type=script&lang=js"
export * from "./submitButton.component.vue?vue&type=script&lang=js"
import style0 from "./submitButton.component.vue?vue&type=style&index=0&id=ef82dc94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef82dc94",
  null
  
)

export default component.exports